import React from 'react';
import { trackingFavoritesItemClick } from './tracking';

import { Undergrounds } from '../Undergrounds';
import { Address } from '../Address';
import { NoFavorites } from '../NoFavorites';
import { EEntityTypes } from '../../repositories/favorites/v1/web-get-user-favorites';
import { IFavoriteEntityForDesktopSchema } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';

interface IFavoritesListProps {
  canLoadMore: boolean;
  favoriteEntities: IFavoriteEntityForDesktopSchema[];
  entityTypes: EEntityTypes.Newbuilding | null;
  updateFavoritesList(length: number): void;
}

export const FavoritesList: React.FC<IFavoritesListProps> = ({
  canLoadMore,
  favoriteEntities,
  entityTypes,
  updateFavoritesList,
}) => {
  const updateFavorites = () => {
    const block = document.querySelector('#c-favorites-wrapper');
    let scrollHeight = block ? block.scrollHeight : 0;
    let scrollTop = block ? block.scrollTop : 0;
    let blockHeigh = block ? (block as HTMLElement).offsetHeight : 0;
    const entityLength = favoriteEntities.length;

    if (canLoadMore && scrollHeight === scrollTop + blockHeigh) {
      updateFavoritesList(entityLength + 10);
    }
  };

  return (
    <div
      id="c-favorites-wrapper"
      className="c-header-modal__notification-wrapper c-header-modal__notification-wrapper--favorites"
      onScroll={updateFavorites}
    >
      {favoriteEntities.length ? (
        favoriteEntities.map(entity => (
          <a
            key={entity.entityId}
            className="c-notification-center__link"
            href={entity.fullUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackingFavoritesItemClick}
          >
            <div className="c-notification-center__block c-notification-center__block--notification">
              <div className="c-notification-center__content">
                <p className="c-notification-center__title">{entity.title}</p>
                <p className="c-notification-center__description">{entity.bargainTerms.priceText}</p>
                {entity.geo &&
                  (entity.geo.undergrounds.length > 0 ? (
                    <Undergrounds undergrounds={entity.geo.undergrounds} />
                  ) : (
                    <Address address={entity.geo.address} />
                  ))}
              </div>
              {entity.photoFullUrl && <img className="c-notification-center__image" src={entity.photoFullUrl} alt="" />}
            </div>
          </a>
        ))
      ) : (
        <NoFavorites isNewbuilding={entityTypes === EEntityTypes.Newbuilding} />
      )}
    </div>
  );
};
